import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/ListingsClickstreamEvents.ts';

const EXPLORE_NEXT_PAGE = defineHotpadsEvent({
  key: 'srp.explore_next_page',
  eventTypeId: '5984',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackNextClickExplorePageEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'button_to_next_page_srp',
    object: 'search_results|explore',
  },
  semanticEvent: 'explore_next_page',
});

const SORT_LISTINGS = defineHotpadsEvent({
  key: 'srp.sort_listings',
  eventTypeId: '5989',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackSortListingsEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'sort_by_dropdown',
    object: 'search_results|header',
  },
  semanticEvent: 'sort_order_changed',
});

const SUGGESTED_AREA = defineHotpadsEvent({
  key: 'srp.suggested_area',
  eventTypeId: '5929',
  eventTypeVersionId: '3',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackSuggestedAreaEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'autocomplete_box',
    object: 'filter_panel',
  },
  semanticEvent: 'search_select_area_suggestion',
});

const TOGGLE_VIEW_MODE = defineHotpadsEvent({
  key: 'srp.toggle_view_mode',
  eventTypeId: '9345',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackToggleViewModeEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'button_to_view_list',
    object: 'search_results_component|view_mode_toggle',
  },
  semanticEvent: 'toggle_view_mode',
});

// Registered as event type 10273 (master 10273.1.171.1) for HP-9162. The apps'
// twins are iOS 5935 and Android 5960: web numbers independently, and Data
// Portal pins `semanticEvent` to `view_content` for every impression, so
// `trigger.source` is what ties the three clients together — not the semantic
// name, and not the id. `no_trigger_object` is the registry's stated standard
// for an impression.
const ZERO_RESULT_SEARCH = defineHotpadsEvent({
  key: 'srp.zero_result_search',
  eventTypeId: '10273',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  trigger: {
    type: 'impression',
    location: 'search_results',
    source: 'search_no_results',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

export function emitTrackNextClickExplorePageEvent() {
  trackHotpadsEventDefinition(EXPLORE_NEXT_PAGE);
}

export function emitTrackSortListingsEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: 'user_item_viewed_page' | 'user_item_hidden_page' | 'user_item_list_page' | 'search_results';
  triggerObject: 'user_item_page|header' | 'search_results|header';
}) {
  trackHotpadsEventDefinition(SORT_LISTINGS, { triggerLocation, triggerObject });
}

export function emitTrackSuggestedAreaEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: 'hp_homepage' | 'search_results' | 'page_not_found';
  triggerObject: 'filter_panel' | 'hp_home_page_component|search' | '404_page|search';
}) {
  trackHotpadsEventDefinition(SUGGESTED_AREA, { triggerLocation, triggerObject });
}

export function emitTrackToggleViewModeEvent({ targetView }: { targetView: 'list' | 'feed' | 'map' }) {
  const triggerSourceMap = {
    list: 'button_to_view_list',
    feed: 'button_to_view_feed',
    map: 'button_to_view_map',
  } satisfies Record<'list' | 'feed' | 'map', string>;

  trackHotpadsEventDefinition(TOGGLE_VIEW_MODE, { triggerSource: triggerSourceMap[targetView] });
}

/**
 * A search that resolved and returned no listings. Fires once per search, not
 * once per render — see `useSrpZeroResultSearch`, which owns that dedupe.
 */
export function emitTrackZeroResultSearchEvent() {
  trackHotpadsEventDefinition(ZERO_RESULT_SEARCH);
}
